<template>
  <v-container class="pt-0" style="height: 100%; background-color: #ffffff">
    <v-row
      ><v-col class="mx-0 px-0 pt-0">
        <header-text-bg
          :site="site"
          text="warrantyRegistration"
          redirect_name="warranty-list"
        />
      </v-col>
    </v-row>

    <!-- ========== ========== AI OCR ========== ========== -->
    <v-row
      v-if="isUseProductLabelOcr"
      class="mx-2"
      style="display: flex; gap: 10px; margin-top: -48px"
    >
      <v-col class="d-flex justify-end py-0 px-0" cols="12">
        <div
          class="d-flex align-center justify-center pa-7"
          style="
            width: 100%;
            z-index: 1;
            border-radius: 16px;
            border-style: dashed;
          "
          :style="{
            'border-color': setBorderAI(),
            'background-color': setBackgroundAI(),
          }"
        >
          <div class="d-flex flex-column align-center">
            <div
              class="d-flex align-center justify-center"
              style="width: 48px; height: 48px; border-radius: 50%"
              :style="{
                'background-color': site.color,
              }"
            >
              <v-icon :color="getFontColorBasedOnBg('bw')"
                >mdi-camera-outline</v-icon
              >
            </div>
            <div
              class="mt-4"
              style="font-size: 18px; font-weight: 800; text-align: center"
              :style="{
                color: site.color,
              }"
            >
              {{ $t("textUploadProductLabel") }}
            </div>
            <div class="gradient-text mb-4" style="text-align: center">
              {{ $t("textAutoFillByAI") }}
            </div>
            <v-btn
              dark
              :color="site.color"
              rounded
              @click="triggerUploadImageLabelProduct"
            >
              {{ $t("textBtnSelectPhoto") }}
            </v-btn>
            <v-btn
              v-if="urlSamplePhoto ? true : false"
              class="mt-3"
              dark
              :color="site.color"
              rounded
              outlined
              :text-color="site.color"
              small
              @click="openDialogSamplePhoto"
            >
              <v-icon small :color="site.color" class="mr-2"
                >mdi-image-outline</v-icon
              >
              {{ $t("textViewSamplePhoto") }}
            </v-btn>
            <input
              type="file"
              ref="fileInput"
              style="display: none"
              accept=".jpg,.jpeg,.png,image/jpeg,image/png"
              @change="handleFileChangeImageLabelProduct"
            />
          </div>
        </div>
      </v-col>
    </v-row>

    <DialogPreviewFile
      :dialogOpen="dialogSamplePhoto"
      :fileUrl="urlSamplePhoto"
      @onClose="closeDialogSamplePhoto"
    />

    <v-row class="px-2 mt-4" style="position: relative; z-index: 2">
      <v-form ref="form" lazy-validation style="width: 100%">
        <v-col cols="12">
          <v-row>
            <v-col cols="12" sm="12" md="12" class="d-flex align-center">
              <v-select
                class="select-product"
                v-model="dataItem.product_id"
                :label="$t('textProduct')"
                :items="listProduct"
                item-text="name"
                item-value="id"
                dense
                hide-details
                outlined
                clearable
                :disabled="
                  listWarrantyRegistration.length ==
                    limitWarrantyRegistration && !dataItem.is_edit
                "
                @change="handleChangeProduct(false)"
              >
                <template #selection="{ item }">
                  <div class="d-flex align-center" style="gap: 8px">
                    <div
                      class="d-flex align-center justify-center"
                      style="
                        width: 24px;
                        min-width: 24px;
                        height: 24px;
                        border-radius: 4px;
                        overflow: hidden;
                      "
                      :style="{
                        background: setBackgoundColorImage(),
                      }"
                    >
                      <v-img
                        v-if="item.image_urls && item.image_urls.length > 0"
                        :src="item.image_urls[0]"
                        style="width: 100%; height: 100%; object-fit: contain"
                        @error="onImageError(item, 'image_urls', 0)"
                      >
                      </v-img>
                      <v-icon
                        v-else
                        :color="getFontColorBasedOnBg('bw')"
                        size="16"
                        >mdi-package-variant-closed</v-icon
                      >
                    </div>
                    <span>{{ item.name }}</span>
                  </div>
                </template>
                <template #item="{ item }">
                  <div
                    class="d-flex align-center"
                    style="gap: 8px; width: 100%"
                  >
                    <div
                      class="d-flex align-center justify-center"
                      style="
                        width: 24px;
                        min-width: 24px;
                        height: 24px;
                        border-radius: 4px;
                        overflow: hidden;
                      "
                      :style="{
                        background: setBackgoundColorImage(),
                      }"
                    >
                      <v-img
                        v-if="item.image_urls && item.image_urls.length > 0"
                        :src="item.image_urls[0]"
                        style="width: 100%; height: 100%; object-fit: contain"
                        @error="onImageError(item, 'image_urls', 0)"
                      >
                      </v-img>
                      <v-icon
                        v-else
                        :color="getFontColorBasedOnBg('bw')"
                        size="16"
                        >mdi-package-variant-closed</v-icon
                      >
                    </div>
                    <span>{{ item.name }}</span>
                  </div>
                </template>
              </v-select>
            </v-col>
            <v-col
              v-if="warrantyFormSchema"
              cols="12"
              sm="12"
              md="12"
              class="py-0"
            >
              <div style="font-weight: 600">{{ $t("textForm") }}</div>
              <SurveyAnswerPage
                ref="refSurveyAnswer"
                :isUseIFrame="false"
                :propSchema="warrantyFormSchema"
                :propSchemaDetail="dataItem.warranty_form_schema_detail"
                :propUseButtonSubmit="false"
                :propListBrandsBranches="warrantyFormSchemaBrandsBranches"
              />
              <div
                v-if="getError(dataItem)"
                style="font-size: 16px; color: #f44336"
              >
                {{ getError(dataItem) }}
              </div>
            </v-col>
            <!-- ========== ========== ========== ========== -->
          </v-row>

          <v-row>
            <!-- List -->
            <v-col
              v-if="listWarrantyRegistration.length > 0"
              cols="12"
              class="pb-0"
            >
              <v-card elevation="2" rounded="lg">
                <div class="pa-2">
                  <div>
                    {{ $t("list") }} ({{ listWarrantyRegistration.length }}/{{
                      limitWarrantyRegistration
                    }})
                  </div>
                  <div class="d-flex flex-wrap mt-4" style="gap: 8px">
                    <div
                      v-for="(item, index) in listWarrantyRegistration"
                      :key="index"
                      style="position: relative"
                    >
                      <div
                        class="d-flex align-center justify-center"
                        style="
                          width: 64px;
                          height: 64px;
                          border-radius: 8px;
                          overflow: hidden;
                          cursor: pointer;
                        "
                        :style="{
                          background: setBackgoundColorImage(),
                          border:
                            dataItem.ref_id == item.ref_id
                              ? '2px solid #2196F3'
                              : '',
                        }"
                        @click="selectItem(index)"
                      >
                        <v-img
                          v-if="
                            productDetail(item.product_id).image_urls &&
                            productDetail(item.product_id).image_urls.length > 0
                          "
                          :src="productDetail(item.product_id).image_urls[0]"
                          style="width: 100%; height: 100%; object-fit: contain"
                          @error="
                            onImageError(
                              productDetail(item.product_id),
                              'image_urls',
                              0
                            )
                          "
                        >
                        </v-img>
                        <v-icon
                          v-else
                          :color="getFontColorBasedOnBg('bw')"
                          size="40"
                          >mdi-package-variant-closed</v-icon
                        >
                      </div>
                      <div style="position: absolute; top: -12px; right: -8px">
                        <v-icon
                          color="red"
                          @click="removeItem(index)"
                          style="background-color: #ffffff; border-radius: 50%"
                        >
                          mdi-close-circle-outline
                        </v-icon>
                      </div>
                      <div
                        v-if="getError(item)"
                        class="d-flex justify-center"
                        style="width: 64px; font-size: 12px; color: #f44336"
                      >
                        {{ getError(item) }}
                      </div>
                    </div>
                  </div>
                </div>
              </v-card>
            </v-col>

            <!-- Button -->
            <v-col cols="12">
              <v-btn
                v-if="isSelected"
                outlined
                class="my-2"
                :color="site.color"
                dark
                style="width: 100%"
                @click="saveSelectItem"
              >
                {{ $t("save") }}
              </v-btn>
              <v-btn
                v-else-if="dataItem.product_id"
                outlined
                class="my-2"
                :color="site.color"
                dark
                style="width: 100%"
                :style="{
                  'background-color':
                    listWarrantyRegistration.length ==
                    limitWarrantyRegistration - 1
                      ? '#E0E0E0 !important'
                      : '',
                  color:
                    listWarrantyRegistration.length ==
                    limitWarrantyRegistration - 1
                      ? '#FFFFFF !important'
                      : site.color,
                }"
                :disabled="
                  listWarrantyRegistration.length ==
                  limitWarrantyRegistration - 1
                "
                @click="addItem"
              >
                + {{ $t("addItem") }}
              </v-btn>

              <v-btn
                v-if="
                  dataItem.product_id || listWarrantyRegistration.length > 0
                "
                class="my-2"
                :color="site.color"
                dark
                style="width: 100%"
                @click="saveData"
              >
                {{ $t("confirmRegistration")
                }}{{
                  listWarrantyRegistration.length > 0
                    ? " (" +
                      listWarrantyRegistration.length +
                      (dataItem.product_id && !dataItem.is_edit ? " + 1" : "") +
                      ")"
                    : ""
                }}
              </v-btn>
            </v-col>
          </v-row>
        </v-col>
      </v-form>
    </v-row>
  </v-container>
</template>

<script>
import { mapState } from "vuex";
import HeaderTextBg from "../../../components/headerTextBg.vue";
import Axios from "@/config/customer-service";
import _ from "lodash";
import SurveyAnswerPage from "../SurveyJS/SurveyAnswerPage.vue";
import {
  adjustHslBrightness,
  getFontColorBasedOnBg,
} from "../../../config/general-function";
import DialogPreviewFile from "../../../components/dialog-preview-file.vue";

export default {
  inject: ["isAppLoading"],
  emits: ["onClick"],
  components: {
    HeaderTextBg,
    SurveyAnswerPage,
    DialogPreviewFile,
  },
  data() {
    return {
      dataItem: {
        ref_id: `${new Date().getTime()}_${Math.random()}`,
        is_edit: false,
        product_id: null,
        warranty_form_id: null,
        warranty_form_schema_detail: null,
        image_label: null,
      },
      listWarrantyRegistration: [],
      limitWarrantyRegistration: 5,
      listWarrantyRegistrationResponse: [],

      listProduct: [],
      warrantyFormSchema: null,
      warrantyFormSchemaBrandsBranches: [],

      dialogSamplePhoto: false,
    };
  },
  async created() {
    this.getListProduct();
  },
  methods: {
    setBorderAI() {
      const color = adjustHslBrightness(this.site.color || "#000000", -20);
      return color;
    },
    setBackgroundAI() {
      const color = adjustHslBrightness(this.site.color || "#000000", 30);
      return color;
    },
    setBackgoundColorImage() {
      const _color = this.site.color || "#0f4c81";
      const lighten = adjustHslBrightness(_color, 20);
      let _style = `linear-gradient(120deg, ${lighten}, ${_color})`;
      return _style;
    },
    getFontColorBasedOnBg(param) {
      const res = getFontColorBasedOnBg(this.site.color, param);
      return res;
    },
    onImageError(item, key, index) {
      if ([null, undefined, ""].includes(index)) {
        item[key] = null;
      } else {
        item[key][index] = null;
        item[key].splice(index, 1);
      }
    },
    productDetail(id) {
      const model = this.listProduct.find((x) => x.id == id);
      return model || {};
    },
    getError(item) {
      let error_label = "";
      const model = this.listWarrantyRegistrationResponse.find(
        (x) => x.ref_id == item.ref_id
      );
      if (!model?.success) {
        error_label = model?.message || "";
      }
      return error_label;
    },
    resetDataItem() {
      this.dataItem = {
        ref_id: `${new Date().getTime()}_${Math.random()}`,
        is_edit: false,
        product_id: null,
        warranty_form_id: null,
        warranty_form_schema_detail: null,
        image_label: null,
      };
      this.warrantyFormSchema = null;
      this.warrantyFormSchemaBrandsBranches = [];
    },

    // ========== ========== ========== ==========
    async getListProduct() {
      try {
        const response = await Axios.get(
          `warranty-registration/getProductWarrantyForm`
        );
        const dataResponse = response?.data;
        if (dataResponse?.status == "success") {
          const data = dataResponse?.data || [];
          this.listProduct = [...data];
          if (this.listProduct.length > 0) {
            // this.dataItem.product_id = this.listProduct[0].id;
            // this.handleChangeProduct(true);
          } else {
            this.$router.push({ name: "warranty-list" });
          }
        }
      } catch (err) {
        console.log("getListProduct", err);
      }
    },
    async handleChangeProduct(is_force_change) {
      this.isAppLoading(true);
      this.warrantyFormSchema = null;
      this.warrantyFormSchemaBrandsBranches = [];
      const sleep = async (msec) => {
        return new Promise((resolve) => {
          setTimeout(() => {
            resolve();
          }, msec || 500);
        });
      };
      await sleep(100);
      // ========== ========== ========== ==========
      const model = this.listProduct.find(
        (x) => x.id == this.dataItem.product_id
      );
      if (!model) {
        this.dataItem.product_id = null;
      }
      this.dataItem.warranty_form_id = model?.warranty_form_id || null;
      this.warrantyFormSchemaBrandsBranches =
        model?.warranty_form_schema_brands_branches || [];
      this.warrantyFormSchema = model?.warranty_form_schema || null;
      if (is_force_change) {
        //
      } else {
        this.dataItem.image_label = null;
      }
      this.isAppLoading(false);
    },
    triggerUploadImageLabelProduct() {
      this.$refs.fileInput.click();
    },
    handleFileChangeImageLabelProduct(event) {
      const file = event.target.files[0];
      if (!file) return;

      const extension = file.name.split(".").pop().toLowerCase();
      const mimeType = file.type.toLowerCase();

      const isHEIC =
        ["heic", "heif"].includes(extension) ||
        mimeType.includes("image/heic") ||
        mimeType.includes("image/heif");

      if (isHEIC) {
        event.target.value = "";
        this.$swal.fire(
          this.$t("error.title"),
          this.$t("error.heicNotSupported"),
          "error"
        );
        return;
      }

      const allowedExtensions = ["jpg", "jpeg", "png"];
      const allowedMimeTypes = ["image/jpeg", "image/png"];

      const isValidExt = allowedExtensions.includes(extension);
      const isValidMime = allowedMimeTypes.includes(mimeType);

      if (!isValidExt || !isValidMime) {
        event.target.value = "";
        this.$swal.fire(
          this.$t("error.title"),
          this.$t("error.imageSupported"),
          "error"
        );
        return;
      }

      this.imageUnderstandingWarrantyRegistration(file);
      event.target.value = "";
    },
    async imageUnderstandingWarrantyRegistration(file) {
      if (!file) return;
      this.isAppLoading(true);
      try {
        this.dataItem.image_label = null;
        // ========== ========== ========== ==========
        const formData = new FormData();
        formData.append("file", file);
        const response = await Axios.post(
          "/warranty-registration/imageUnderstandingWarrantyRegistration",
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        );
        const dataResponse = response?.data;
        if (dataResponse?.status == "success") {
          const data = dataResponse.data;
          const product_name = data?.product_name;
          const serial_number = data?.serial_number;
          const model = data?.model;
          let checkProductFound = false;
          let elements = this.warrantyFormSchema?.elements || [];
          if (product_name) {
            const model = this.listProduct.find((x) => x.name == product_name);
            if (model) {
              checkProductFound = true;
              this.dataItem.product_id = model.id;
              elements = model.warranty_form_schema?.elements || [];
            }
          }
          if (elements.length > 0) {
            let schema_detail = {};
            if (this.$refs.refSurveyAnswer) {
              schema_detail = await this.$refs.refSurveyAnswer.getCurrentData();
            }
            const model_serial_number = elements.find(
              (x) => x.name == "serial_number"
            );
            if (model_serial_number) {
              schema_detail = {
                ...schema_detail,
                serial_number: serial_number,
              };
            }
            const model_model = elements.find((x) => x.name == "model");
            if (model_model) {
              schema_detail = {
                ...schema_detail,
                model: model,
              };
            }
            const model_image_label = elements.find(
              (x) => x.name == "image_label"
            );
            if (model_image_label) {
              const _image = await this.uploadImageDefault(
                file,
                "ImageProductLabel"
              );
              if (_image) {
                const fileName = file.name;
                const mimeType = file.type.toLowerCase();
                const detail = [
                  {
                    content: _image,
                    name: fileName,
                    type: mimeType,
                  },
                ];
                schema_detail = {
                  ...schema_detail,
                  image_label: detail,
                };
                this.dataItem.image_label = _image || null;
              }
            }
            this.dataItem.warranty_form_schema_detail = schema_detail;
            // ========== ========== ========== ==========
          }
          await this.handleChangeProduct(true);
          if (!checkProductFound) {
            this.$swal.fire(
              this.$t("error.title"),
              this.$t("error.ocrProductNotFound"),
              "error"
            );
          }
        } else {
          this.$swal.fire(
            this.$t("error.title"),
            dataResponse?.message,
            "error"
          );
        }
      } catch (err) {
        this.$swal.fire(
          this.$t("error.title"),
          err?.response?.data?.error,
          "error"
        );
      }
      this.isAppLoading(false);
    },
    openDialogSamplePhoto() {
      this.dialogSamplePhoto = true;
    },
    closeDialogSamplePhoto() {
      this.dialogSamplePhoto = false;
    },

    // ========== ========== ========== ==========
    showErrorRequired() {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: "smooth",
      });
    },
    async validation() {
      let validateSchema = false;
      if (this.warrantyFormSchema) {
        if (this.$refs.refSurveyAnswer) {
          const schema_detail = await this.$refs.refSurveyAnswer.handleSubmit();
          this.dataItem.warranty_form_schema_detail = schema_detail;
          if (!schema_detail) {
            validateSchema = true;
          }
        }
      }
      if (!this.$refs.form.validate(true) || validateSchema) {
        this.showErrorRequired();
        return false;
      }
      return true;
    },
    async addItem() {
      const validate = await this.validation();
      if (!validate) {
        return;
      }
      // ========== ========== ========== ==========
      const index = this.listWarrantyRegistration.findIndex(
        (x) => x.ref_id == this.dataItem.ref_id
      );
      if (index >= 0) {
        this.listWarrantyRegistration[index] = this.dataItem;
      } else {
        this.listWarrantyRegistration.push(this.dataItem);
      }
      this.resetDataItem();
    },
    removeItem(index) {
      const model = this.listWarrantyRegistration[index];
      if (model.ref_id == this.dataItem.ref_id) {
        this.resetDataItem();
      }
      this.listWarrantyRegistration.splice(index, 1);
    },
    async selectItem(index) {
      const model = this.listWarrantyRegistration[index];
      if (model.ref_id == this.dataItem.ref_id) {
        this.resetDataItem();
      } else {
        const validate = await this.validation();
        if (!validate) {
          return;
        }
        // ========== ========== ========== ==========
        if (this.dataItem.product_id) {
          const index = this.listWarrantyRegistration.findIndex(
            (x) => x.ref_id == this.dataItem.ref_id
          );
          if (index >= 0) {
            this.listWarrantyRegistration[index] = this.dataItem;
          } else {
            this.listWarrantyRegistration.push(this.dataItem);
          }
        }
        // ========== ========== ========== ==========
        this.dataItem = {
          ...model,
          is_edit: true,
        };
        await this.handleChangeProduct(true);
      }
    },
    async saveSelectItem() {
      const validate = await this.validation();
      if (!validate) {
        return;
      }
      // ========== ========== ========== ==========
      const index = this.listWarrantyRegistration.findIndex(
        (x) => x.ref_id == this.dataItem.ref_id
      );
      if (index >= 0) {
        this.listWarrantyRegistration[index] = this.dataItem;
      }
      this.resetDataItem();
    },
    async saveData() {
      const validate = await this.validation();
      if (!validate) {
        return;
      }
      // ========== ========== ========== ==========
      if (this.dataItem.product_id) {
        const index = this.listWarrantyRegistration.findIndex(
          (x) => x.ref_id == this.dataItem.ref_id
        );
        if (index >= 0) {
          this.listWarrantyRegistration[index] = this.dataItem;
        } else {
          this.listWarrantyRegistration.push(this.dataItem);
        }
      }
      // ========== ========== ========== ==========
      this.isAppLoading(true);
      const list_warranty_registration = _.cloneDeep(
        this.listWarrantyRegistration
      );
      this.listWarrantyRegistrationResponse = [];
      try {
        const response = await Axios.post(
          "/warranty-registration/createWarrantyRegistration",
          {
            list_warranty_registration: list_warranty_registration,
          }
        );
        const dataResponse = response?.data;
        if (dataResponse?.status == "success") {
          if (list_warranty_registration.length == 1) {
            const model = dataResponse.data[0];
            if (model.success) {
              this.$swal
                .fire({
                  icon: "success",
                  title: this.$t("saveSuccess"),
                  showConfirmButton: false,
                  timer: 2000,
                })
                .then(() => {
                  this.$router.push({
                    name: `warranty-list`,
                  });
                  this.isAppLoading(false);
                });
            } else {
              this.$swal.fire(this.$t("error.title"), model?.message, "error");
              this.isAppLoading(false);
            }
          } else {
            this.listWarrantyRegistrationResponse = dataResponse.data
              ? [...dataResponse.data]
              : [];
            const has_error = this.listWarrantyRegistrationResponse.find(
              (x) => !x.success
            );
            if (has_error) {
              this.resetDataItem();
              this.selectItem(list_warranty_registration.length - 1);
              this.isAppLoading(false);
            } else {
              this.$swal
                .fire({
                  icon: "success",
                  title: this.$t("saveSuccess"),
                  showConfirmButton: false,
                  timer: 2000,
                })
                .then(() => {
                  this.$router.push({
                    name: `warranty-list`,
                  });
                  this.isAppLoading(false);
                });
            }
          }
        } else {
          this.$swal.fire(
            this.$t("error.title"),
            dataResponse?.message,
            "error"
          );
          this.isAppLoading(false);
        }
      } catch (err) {
        this.$swal.fire(
          this.$t("error.title"),
          err?.response?.data?.error,
          "error"
        );
        this.isAppLoading(false);
      }
      // ========== ========== ========== ==========
      this.resetDataItem();
    },
    uploadImageDefault(file, my_module) {
      if (file) {
        let formData = new FormData();
        formData.append("image", file);
        formData.append("module", my_module);
        return new Promise((resolve, reject) => {
          Axios.post("uploadImageDefault", formData, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          })
            .then(({ data }) => {
              if (data.status == "success") {
                resolve(data.image_url);
              }
            })
            .catch((err) => {
              console.log(err);
              reject(null);
            });
        });
      } else {
        return null;
      }
    },
  },
  computed: {
    ...mapState("defaultSystem", ["site", "customer"]),
    normalRules() {
      return [(v) => !!v || this.$t("required")];
    },
    isUseProductLabelOcr() {
      return this.site.is_use_product_label_ocr || false;
    },
    urlSamplePhoto() {
      return (
        this.site.is_use_product_label_ocr &&
        this.site.ai_image_detail &&
        this.site.ai_image_detail.product_label_ocr_detail &&
        this.site.ai_image_detail.product_label_ocr_detail
          .sample_image_product_label_ocr
      );
    },
    isSelected() {
      let selected = false;
      const model = this.listWarrantyRegistration.find(
        (x) => x.ref_id == this.dataItem.ref_id
      );
      if (model) {
        selected = true;
      }
      return selected;
    },
  },
  watch: {},
  filters: {},
};
</script>

<style scoped>
::v-deep .ql-editor {
  max-height: 640px;
  overflow-y: auto;
  overflow-x: hidden;
  min-height: 200px;
}

::v-deep .sd-body {
  padding-left: 4px !important;
  padding-right: 4px !important;
  padding-bottom: 4px !important;
  max-width: 100% !important;
}

::v-deep .sd-page {
  padding-left: 0px !important;
  padding-right: 0px !important;
}

::v-deep .sd-root-modern {
  background: transparent !important;
}

::v-deep .v-btn__content {
  display: flex;
  flex-direction: row;
}

::v-deep .select-product input {
  display: none !important;
}

.gradient-text {
  /* 1. สร้าง gradient เป็น background */
  background-image: linear-gradient(90deg, #ff0084, #3300ff, #6600ff);

  /* 2. ทำให้ gradient แสดงเฉพาะในส่วนที่เป็นข้อความ */
  background-clip: text;
  -webkit-background-clip: text; /* สำหรับ Safari และเบราว์เซอร์ที่ใช้ WebKit */

  /* 3. ทำให้สีของข้อความโปร่งใส เพื่อให้ background แสดงขึ้นมา */
  color: transparent;
  -webkit-text-fill-color: transparent; /* สำหรับ Safari และเบราว์เซอร์ที่ใช้ WebKit */

  /* คุณสมบัติเพิ่มเติมเพื่อความสวยงาม */
  font-size: 16px; /* ขนาดตัวอักษร */
  font-weight: 600; /* ตัวหนา */
  display: inline-block; /* สำคัญสำหรับบางเบราว์เซอร์ */
}
</style>
